import {
  selectOrganizationPaymentPlan,
  selectOrganizationStatus,
} from '@app/routes/organization/selectors';
import { selectOrganizationId } from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';
import { GraphqlProvider } from '@hopin-team/dashboard-shared-react';
import { useTranslation } from '@hopin-team/provider-translation';
import { Loading as LoadingUI } from '@hopin-team/ui-loading';
import React from 'react';

import { TabContent } from './features/top-bar/tab-content';
import { TopBar } from './features/top-bar/top-bar';
import { UpgradeBanner } from './features/upgrade-banner/upgrade-banner';
import { AnalyticsProvider } from './providers/analytics-provider';
import { AuthenticationProvider } from './providers/authentication-provider';
import { getHost } from './services/endpoints';

const Loading = () => {
  const { t } = useTranslation();
  return <LoadingUI text={t('loading')} poweredByText={t('poweredBy')} />;
};

const AnalyticsPage = () => {
  const orgId = useAppSelector(selectOrganizationId) || '';
  const paymentPlan = useAppSelector(selectOrganizationPaymentPlan);
  const organizationDataStatus = useAppSelector(selectOrganizationStatus);

  const freeTrialEnabled = paymentPlan?.planName?.toLowerCase() === 'free';

  if (organizationDataStatus !== 'success') {
    return <Loading />;
  }

  return (
    <>
      {freeTrialEnabled ? (
        <UpgradeBanner
          organizationId={orgId}
          freeTrialEnabled={freeTrialEnabled}
        />
      ) : (
        <div className="pb-10">
          <TopBar />
          <TabContent />
        </div>
      )}
    </>
  );
};

export const Analytics = () => {
  const orgId = useAppSelector(selectOrganizationId) || '';
  const host: string = getHost();

  return (
    <GraphqlProvider fallback={<Loading />}>
      <AuthenticationProvider host={host} organisationId={orgId}>
        <AnalyticsProvider>
          <div className="relative">
            <div className="mx-auto px-6 max-w-[90rem]">
              <AnalyticsPage />
            </div>
          </div>
        </AnalyticsProvider>
      </AuthenticationProvider>
    </GraphqlProvider>
  );
};
